import { WifiOff } from 'lucide-react';
import { useBrowserNetworkStatus } from 'src/hooks/useBrowserNetworkStatus';

export function OfflineBanner() {
  const { isOnline } = useBrowserNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center bg-background/95 backdrop-blur-xs">
      <div className="flex flex-col items-center gap-4 text-center px-6 max-w-sm">
        <div className="rounded-full bg-muted p-4">
          <WifiOff className="h-8 w-8 text-muted-foreground" />
        </div>
        <h2 className="text-lg font-semibold text-foreground">You are offline</h2>
        <p className="text-sm text-muted-foreground">
          The app will reconnect automatically when your network returns.
        </p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground/60">
          <div className="h-2 w-2 rounded-full bg-yellow-500 animate-pulse" />
          Waiting for connection...
        </div>
      </div>
    </div>
  );
}
